import { DAY_START_HOUR } from './useTimelineData';

interface DensityBarProps {
  buckets: number[];
  peak: number;
  fullWidth?: boolean;
}

export default function DensityBar({ buckets, peak, fullWidth = false }: DensityBarProps) {
  if (peak === 0) return null;

  return (
    <div>
      <div
        className={`flex items-end gap-0 ${fullWidth ? 'w-full' : ''}`}
        style={fullWidth ? undefined : { width: 1440 }}
      >
        {buckets.map((count, i) => {
          const intensity = count / peak;
          // Convert bucket index back to absolute time
          const absH = (DAY_START_HOUR + Math.floor(i / 2)) % 24;
          const m = (i % 2) * 30;
          const label = `${String(absH).padStart(2, '0')}:${String(m).padStart(2, '0')} — ${count} merchant${count !== 1 ? 's' : ''}`;
          return (
            <div
              key={i}
              className={`relative group ${fullWidth ? 'flex-1 h-10' : 'h-6'} flex items-center justify-center`}
              style={{
                width: fullWidth ? undefined : 30,
                backgroundColor: count === 0
                  ? '#f3f4f6'
                  : `rgba(139, 92, 246, ${0.15 + intensity * 0.85})`,
              }}
              title={label}
            >
              {fullWidth && count > 0 && (
                <span className={`text-[10px] font-medium ${intensity > 0.5 ? 'text-white' : 'text-purple-900'}`}>
                  {count}
                </span>
              )}
              <div className="hidden group-hover:block absolute bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap z-20 pointer-events-none">
                {label}
              </div>
            </div>
          );
        })}
      </div>
      {fullWidth && (
        <div className="flex w-full">
          {buckets.map((_, i) => (
            <div key={i} className="flex-1 text-center">
              {i % 2 === 0 && (
                <span className="text-[9px] text-gray-500">
                  {String((DAY_START_HOUR + Math.floor(i / 2)) % 24).padStart(2, '0')}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
